export var FORMS_BACKEND_PROXY_URL = "/api/x-forms";
export var RENDER_FORMS_URL_PREFIX = "/app/x-forms/forms/";
export var RENDER_NPS_URL_PREFIX = "/app/x-forms/nps/";
export var PREVIEW_QUERY_PARAM = "isPreview";
export var DEFAULT_CREATOR_OPTIONS = {
    showLogicTab: true,
    isAutoSave: true,
};
export var FORM_STEPS = [
    "Estrutura do Formulário",
    "Configurações do Formulário",
];
export var FORM_LOCALE = "pt";
export var SEARCH_FIELD_OPTIONS = [
    { value: "title", label: "Título" },
    { value: "description", label: "Descrição" },
    { value: "slug", label: "Slug" },
];
export var SEARCH_DEBOUNCE_MS = 400;
